import { render, staticRenderFns } from "./CreateUserCompany.vue?vue&type=template&id=ffa8a4fe&scoped=true&"
import script from "./CreateUserCompany.vue?vue&type=script&lang=js&"
export * from "./CreateUserCompany.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "@/assets/styles/login.css?vue&type=style&index=1&id=ffa8a4fe&prod&scoped=true&lang=css&"
import style2 from "./CreateUserCompany.vue?vue&type=style&index=2&id=ffa8a4fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa8a4fe",
  null
  
)

export default component.exports